import { getWindow } from '@ztechapps/common.utils'

export const toggleAttribute = (attribute: string, value: string) => {
  const win = getWindow()
  if (!win) return
  win.document.documentElement.setAttribute(attribute, value)
}

export const showBackdrop = () => {
  const win = getWindow()
  if (!win) return

  const htmlEl = win.document.documentElement
  const backdropEl = win.document.createElement('div')
  backdropEl.id = 'custom-backdrop'
  backdropEl.className = 'offcanvas-backdrop fade show'
  win.document.body.appendChild(backdropEl)
  win.document.body.style.overflow = 'hidden'

  if (win.innerWidth > 767) {
    win.document.body.style.paddingRight = '15px'
  }

  htmlEl.classList.add('sidebar-enable')

  backdropEl.addEventListener('click', () => {
    hideBackdrop()
  })
}

export const hideBackdrop = () => {
  const win = getWindow()
  if (!win) return

  const htmlEl = win.document.documentElement
  htmlEl.classList.remove('sidebar-enable')

  const backdropEl = win.document.getElementById('custom-backdrop')
  if (backdropEl) {
    win.document.body.removeChild(backdropEl)
    win.document.body.style.overflow = ''
    win.document.body.style.paddingRight = ''
  }
}
